import { useCatalogActionsContext } from "@components/Actions/CatalogActions/CatalogActionsContext";
import ShareAction from "@ext/catalog/actions/share/components/ShareAction";
import type { ReactNode } from "react";

interface ShareCatalogItemProps {
	children?: ReactNode;
	copyOnly?: boolean;
}

const ShareCatalogItem = ({ children, copyOnly }: ShareCatalogItemProps) => {
	const { pathName } = useCatalogActionsContext();

	return (
		<ShareAction copyOnly={copyOnly} isArticle={false} path={`/${pathName}`}>
			{children}
		</ShareAction>
	);
};

export default ShareCatalogItem;
